/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Inventories,
  Inventory,
  InventoryItem,
  InventoryItems,
  SchemaValidationErrorResponse,
  StandardError,
  UserInventoriesParams,
  UserInventoryItemsParams
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary User Inventories list
 */
export const userInventories = (
    userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoriesParams>,
 signal?: AbortSignal
) => {
      userId = toValue(userId);
params = toValue(params);

      return axiosClient<Inventories>(
      {url: `/users/${userId}/inventories`, method: 'GET',
        params, signal
    },
      );
    }




export const getUserInventoriesQueryKey = (userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoriesParams>,) => {
    return [
    'users',userId,'inventories', ...(params ? [params] : [])
    ] as const;
    }


export const getUserInventoriesQueryOptions = <TData = Awaited<ReturnType<typeof userInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserInventoriesQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userInventories>>> = ({ signal }) => userInventories(userId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userInventories>>, TError, TData>
}

export type UserInventoriesQueryResult = NonNullable<Awaited<ReturnType<typeof userInventories>>>
export type UserInventoriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary User Inventories list
 */

export function useUserInventories<TData = Awaited<ReturnType<typeof userInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 userId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserInventoriesQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary One user inventory
 */
export const userInventory = (
    userId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      userId = toValue(userId);
id = toValue(id);

      return axiosClient<Inventory>(
      {url: `/users/${userId}/inventories/${id}`, method: 'GET', signal
    },
      );
    }




export const getUserInventoryQueryKey = (userId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'users',userId,'inventories',id
    ] as const;
    }


export const getUserInventoryQueryOptions = <TData = Awaited<ReturnType<typeof userInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(userId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserInventoryQueryKey(userId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userInventory>>> = ({ signal }) => userInventory(userId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userInventory>>, TError, TData>
}

export type UserInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof userInventory>>>
export type UserInventoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary One user inventory
 */

export function useUserInventory<TData = Awaited<ReturnType<typeof userInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 userId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserInventoryQueryOptions(userId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Inventory Items list
 */
export const userInventoryItems = (
    userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoryItemsParams>,
 signal?: AbortSignal
) => {
      userId = toValue(userId);
inventoryId = toValue(inventoryId);
params = toValue(params);

      return axiosClient<InventoryItems>(
      {url: `/users/${userId}/inventories/${inventoryId}/items`, method: 'GET',
        params, signal
    },
      );
    }




export const getUserInventoryItemsQueryKey = (userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoryItemsParams>,) => {
    return [
    'users',userId,'inventories',inventoryId,'items', ...(params ? [params] : [])
    ] as const;
    }


export const getUserInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof userInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserInventoryItemsQueryKey(userId,inventoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userInventoryItems>>> = ({ signal }) => userInventoryItems(userId,inventoryId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined && toValue(inventoryId) !== null && toValue(inventoryId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userInventoryItems>>, TError, TData>
}

export type UserInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof userInventoryItems>>>
export type UserInventoryItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Inventory Items list
 */

export function useUserInventoryItems<TData = Awaited<ReturnType<typeof userInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UserInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserInventoryItemsQueryOptions(userId,inventoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary One inventory item
 */
export const userInventoryItem = (
    userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      userId = toValue(userId);
inventoryId = toValue(inventoryId);
id = toValue(id);

      return axiosClient<InventoryItem>(
      {url: `/users/${userId}/inventories/${inventoryId}/items/${id}`, method: 'GET', signal
    },
      );
    }




export const getUserInventoryItemQueryKey = (userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'users',userId,'inventories',inventoryId,'items',id
    ] as const;
    }


export const getUserInventoryItemQueryOptions = <TData = Awaited<ReturnType<typeof userInventoryItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getUserInventoryItemQueryKey(userId,inventoryId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userInventoryItem>>> = ({ signal }) => userInventoryItem(userId,inventoryId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined && toValue(inventoryId) !== null && toValue(inventoryId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userInventoryItem>>, TError, TData>
}

export type UserInventoryItemQueryResult = NonNullable<Awaited<ReturnType<typeof userInventoryItem>>>
export type UserInventoryItemQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary One inventory item
 */

export function useUserInventoryItem<TData = Awaited<ReturnType<typeof userInventoryItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 userId: MaybeRefOrGetter<string>,
    inventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userInventoryItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserInventoryItemQueryOptions(userId,inventoryId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






